<template>
  <v-btn
      color="primary"
      :loading="isLoading"
      :disabled="isDisabled"
      v-on="$listeners"
  >
    <v-icon left>mdi-content-save</v-icon>
    Guardar cambios
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "SaveButton",
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
  }
});
</script>